// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.find_face {
  min-height: 80vh;
  overflow: auto;
}
.find_face::-webkit-scrollbar {
  width: 0.7em;
  height: 0.7em;
}
.find_face::-webkit-scrollbar-thumb {
  background: #3b00f8;
}
.find_face::-webkit-scrollbar-track {
  background: #9d80fc;
}
@media (max-width: 600px) {
  .find_face::-webkit-scrollbar {
    width: 0em;
    height: 0em;
  }
  .find_face::-webkit-scrollbar-thumb {
    background: #fff;
  }
  .find_face::-webkit-scrollbar-track {
    background: white;
  }
}
.find_face .face_lookup {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  gap: 10px;
  margin: 2vh auto;
}
.find_face .face_lookup input {
  height: 4vh;
  width: 300px;
  border-radius: 5px;
}
.find_face .face_lookup .lookup_btn {
  background-color: #151042;
  width: 150px;
}
@media (max-width: 1000px) {
  .find_face .face_lookup {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 10px;
  }
  .find_face .face_lookup input {
    width: 95vw;
  }
  .find_face .face_lookup .lookup_btn {
    background-color: #151042;
    width: 95vw;
  }
}
.find_face .alert_section {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 0;
  margin: 2vh auto;
  height: 4vh;
}
.find_face .alert_section .alert_box {
  background-color: #151042;
  color: #fff;
  font-weight: 700;
  margin: 0;
  padding: 0;
  width: 300px;
  text-align: center;
  justify-content: center;
}
.find_face .details_section {
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 2rem;
  height: 100vh;
  padding: 1rem;
  box-sizing: border-box;
}
.find_face .details_section .left-column,
.find_face .details_section .right-column {
  display: flex;
  flex-direction: column;
}
.find_face .details_section .left-column {
  align-items: center;
  border-right: 1px solid #e0e0e0;
  overflow: visible;
}
.find_face .details_section .img_container {
  min-height: 350px;
  max-height: 350px;
  border: 1px solid #000;
  border-radius: 5px;
  width: 350px;
  margin: 0 auto;
  margin-bottom: 2vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.find_face .details_section .img_container .face_image {
  width: 300px;
  max-width: 300px;
  max-height: 300px;
  border-radius: 5px;
}
@media (max-width: 1000px) {
  .find_face .details_section .img_container .face_image {
    width: 95vw;
    max-width: 95vw;
  }
}
.find_face .details_section .header_details {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  gap: 10px;
  flex-wrap: wrap;
}
.find_face .details_section .header_details h2 {
  color: #151042;
  font-weight: 700;
  font-size: 1.1rem;
  border: 3px solid #151042;
  width: 300px;
  border-radius: 5px;
  margin: 0;
  height: 4vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  gap: 10px;
}
.find_face .details_section .header_details h2 span {
  color: #000;
}
.find_face .details_section .header_details h2 .update_btn {
  height: 3.5vh;
}
.find_face .details_section .header_details button {
  width: 306px;
  height: 4.2vh;
  background-color: #ffe169;
  color: #151042;
  font-weight: 700;
}
@media (max-width: 1000px) {
  .find_face .details_section .header_details h2,
  .find_face .details_section .header_details button {
    width: 95vw;
  }
}
.find_face .details_section .right-column {
  overflow-y: auto;
  padding-right: 1rem;
  position: relative;
}
.find_face .details_section .face_info_table {
  width: 1000px;
  table-layout: fixed;
}
@media (max-width: 1000px) {
  .find_face .details_section .face_info_table td:nth-of-type(1):before {
    content: "Date/Time";
  }
  .find_face .details_section .face_info_table td:nth-of-type(2):before {
    content: "Store";
  }
  .find_face .details_section .face_info_table td:nth-of-type(3):before {
    content: "Logs";
  }
}
.find_face .details_section .face_info_table .log_btn {
  background-color: #151042;
}

.logs_modal {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 10px;
}
.logs_modal h2 {
  margin: 0;
}
.logs_modal .table_container {
  overflow-y: auto;
}
.logs_modal .table_container table {
  width: 100%;
}
@media (max-width: 1000px) {
  .logs_modal .table_container table td:nth-of-type(1):before {
    content: "Note";
  }
  .logs_modal .table_container table td:nth-of-type(2):before {
    content: "Date/Time";
  }
}
.logs_modal button {
  width: 100%;
}

.update_dialog {
  width: 300px;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 10px;
}
.update_dialog .update_select select {
  height: 4vh;
  width: 300px;
  border-radius: 5px;
}
.update_dialog .btn_section {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  flex-direction: row;
  gap: 10px;
  width: 100%;
}
.update_dialog .btn_section button {
  width: 49%;
}`, "",{"version":3,"sources":["webpack://./src/components/styles/findface.scss","webpack://./src/variables.scss"],"names":[],"mappings":"AAEA;EACI,gBCgBU;EDfV,cAAA;AADJ;AC4DI;EACI,YD3DgB;EC4DhB,aD5DgB;AAExB;AC6DI;EACI,mBAxDO;ADHf;AC8DI;EACI,mBAbe;AD/CvB;AAPI;ECyDA;IACI,UDzDoB;IC0DpB,WD1DoB;EAW1B;ECkDE;IACI,gBA9DA;EDcN;ECmDE;IACI,iBAbe;EDpCrB;AACF;AAfI;ECmBA,aAAA;EACA,uBDnBkB;ECoBlB,mBDpB0B;ECqB1B,mBDrBkC;ECsBlC,SDtBuC;EACnC,gBAAA;AAqBR;AAnBQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;AAqBZ;AAlBQ;EACI,yBCTO;EDUP,YAAA;AAoBZ;AAjBQ;EAfJ;ICmBA,aAAA;IACA,uBDJsB;ICKtB,mBDL8B;ICM9B,sBDNsC;ICOtC,SDP8C;EAwBhD;EAvBU;IACI,WAAA;EAyBd;EAvBU;IACI,yBCnBG;IDoBH,WAAA;EAyBd;AACF;AAtBI;ECPA,aAAA;EACA,uBDOkB;ECNlB,mBDM0B;ECL1B,sBDKkC;ECJlC,MDI0C;EACtC,gBAAA;EACA,WAAA;AA4BR;AA3BQ;EACI,yBC7BO;ED8BP,WCnCJ;EDoCI,gBAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;AA6BZ;AAzBI;EAEI,aAAA;EACA,8BAAA;EACA,SAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;AA0BR;AAvBQ;;EAEI,aAAA;EACA,sBAAA;AAyBZ;AAtBQ;EACA,mBAAA;EACA,+BAAA;EACA,iBAAA;AAwBR;AApBQ;EACI,iBAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAsBZ;AArBY;EACI,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AAuBhB;AArBgB;EANJ;IAOQ,WAAA;IACA,eAAA;EAwBlB;AACF;AApBQ;ECtEJ,aAAA;EACA,uBDsEsB;ECrEtB,mBDqE8B;ECpE9B,mBDoEsC;ECnEtC,SDmE2C;EACnC,eAAA;AA0BZ;AAxBY;EACI,cC5FG;ED6FH,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EClFZ,aAAA;EACA,uBDmF0B;EClF1B,mBDkFkC;ECjFlC,mBAJsD;EAKtD,SALiE;ADkHrE;AA5BgB;EACI,WC3GZ;ADyIR;AA5BgB;EACI,aAAA;AA8BpB;AA3BY;EACI,YAAA;EACA,aAAA;EACA,yBC7GC;ED8GD,cCjHG;EDkHH,gBAAA;AA6BhB;AA3BY;EACI;;IAEI,WAAA;EA6BlB;AACF;AAzBQ;EACI,gBAAA;EACA,mBAAA;EACA,kBAAA;AA2BZ;AAxBQ;EAEI,aAAA;EACA,mBAAA;AAyBZ;AAvBY;EACI;IACI,oBAAA;EAyBlB;EAvBc;IACI,gBAAA;EAyBlB;EAvBc;IACI,eAAA;EAyBlB;AACF;AAtBY;EACI,yBCpJG;AD4KnB;;AAhBA;EC3II,aAAA;EACA,uBD2Ic;EC1Id,mBD0IsB;ECzItB,sBDyI8B;ECxI9B,SDwIsC;AAuB1C;AAtBI;EACI,SAAA;AAwBR;AAtBI;EACI,gBAAA;AAwBR;AAtBQ;EACI,WAAA;AAwBZ;AAvBY;EACI;IACI,eAAA;EAyBlB;EAvBc;IACI,oBAAA;EAyBlB;AACF;AArBI;EACI,WAAA;AAuBR;;AAnBA;EACI,YAAA;EACA,aAAA;ECtKA,aAAA;EACA,uBDsKc;ECrKd,mBDqKsB;ECpKtB,sBDoK8B;ECnK9B,SDmKsC;AA0B1C;AAvBQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;AAyBZ;AArBI;ECjLA,aAAA;EACA,6BDiLkB;EChLlB,mBDgLgC;EC/KhC,mBD+KwC;EC9KxC,SD8K6C;EACzC,WAAA;AA2BR;AA1BQ;EACI,UAAA;AA4BZ","sourcesContent":["@import \"../../variables.scss\";\n\n.find_face {\n    min-height: $main-height;\n    overflow: auto;\n    @include scrollbars(0.7em, $nitrocamBlue);\n    @media (max-width: $mobile) {\n        @include scrollbars(0em, $white);\n    }\n\n    .face_lookup {\n        @include flex(center, center, row, 10px);\n        margin: 2vh auto;\n\n        input {\n            height: 4vh;\n            width: 300px;\n            border-radius: 5px;\n        }\n\n        .lookup_btn {\n            background-color: $nitrocamDarkBlue;\n            width: 150px;\n        }\n\n        @media (max-width: $tablet) {\n            @include flex(center, center, column, 10px);\n            input {\n                width: 95vw;\n            }\n            .lookup_btn {\n                background-color: $nitrocamDarkBlue;\n                width: 95vw;\n            }\n        }\n    }\n    .alert_section {\n        @include flex(center, center, column, 0);\n        margin: 2vh auto;\n        height: 4vh;\n        .alert_box {\n            background-color: $nitrocamDarkBlue;\n            color: $white;\n            font-weight: 700;\n            margin: 0;\n            padding: 0;\n            width: 300px;\n            text-align: center;\n            justify-content: center;\n        }\n    }\n\n    .details_section {\n\n        display: grid;\n        grid-template-columns: 1fr 2fr; \n        gap: 2rem;\n        height: 100vh; \n        padding: 1rem;\n        box-sizing: border-box;\n        \n\n        .left-column,\n        .right-column {\n            display: flex;\n            flex-direction: column;\n        }\n\n        .left-column {\n        align-items: center;\n        border-right: 1px solid #e0e0e0;\n        overflow: visible;\n        }\n\n\n        .img_container {\n            min-height: 350px;\n            max-height: 350px;\n            border: 1px solid #000;\n            border-radius: 5px;\n            width: 350px;\n            margin: 0 auto;\n            margin-bottom: 2vh;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            .face_image {\n                width: 300px;\n                max-width: 300px;\n                max-height: 300px;\n                border-radius: 5px;\n\n                @media (max-width: $tablet) {\n                    width: 95vw;\n                    max-width: 95vw;\n                }\n            }\n        }\n\n        .header_details {\n            @include flex(center, center, row, 10px);\n            flex-wrap: wrap;\n\n            h2 {\n                color: $nitrocamDarkBlue;\n                font-weight: 700;\n                font-size: 1.1rem;\n                border: 3px solid $nitrocamDarkBlue;\n                width: 300px;\n                border-radius: 5px;\n                margin: 0;\n                height: 4vh;\n\n                @include flex(center, center);\n                span {\n                    color: $black;\n                }\n                .update_btn {\n                    height: 3.5vh;\n                }\n            }\n            button {\n                width: 306px;\n                height: 4.2vh;\n                background-color: $nitrocamYellow;\n                color: $nitrocamDarkBlue;\n                font-weight: 700;\n            }\n            @media (max-width: $tablet) {\n                h2,\n                button {\n                    width: 95vw;\n                }\n            }\n        }\n\n        .right-column {\n            overflow-y: auto; \n            padding-right: 1rem;\n            position: relative;\n        }\n\n        .face_info_table {\n\n            width: 1000px;\n            table-layout: fixed;\n\n            @media (max-width: $tablet) {\n                td:nth-of-type(1):before {\n                    content: \"Date/Time\";\n                }\n                td:nth-of-type(2):before {\n                    content: \"Store\";\n                }\n                td:nth-of-type(3):before {\n                    content: \"Logs\";\n                }\n            }\n\n            .log_btn {\n                background-color: $nitrocamDarkBlue;\n            }\n        }\n    }\n}\n\n\n\n.logs_modal {\n    @include flex(center, center, column, 10px);\n    h2 {\n        margin: 0;\n    }\n    .table_container {\n        overflow-y: auto;\n\n        table {\n            width: 100%;\n            @media (max-width: $tablet) {\n                td:nth-of-type(1):before {\n                    content: \"Note\";\n                }\n                td:nth-of-type(2):before {\n                    content: \"Date/Time\";\n                }\n            }\n        }\n    }\n    button {\n        width: 100%;\n    }\n}\n\n.update_dialog {\n    width: 300px;\n    padding: 10px;\n    @include flex(center, center, column, 10px);\n\n    .update_select {\n        select {\n            height: 4vh;\n            width: 300px;\n            border-radius: 5px;\n        }\n    }\n\n    .btn_section {\n        @include flex(space-evenly, center, row, 10px);\n        width: 100%;\n        button {\n            width: 49%;\n        }\n    }\n}\n","//Colors\n$nitroDark: #2c53a0;\n$nitroLight: #64c4e0;\n$background: #e4ffff;\n$fontColor: #4d4d4d;\n$error: #bb0000;\n$warning: #f29422;\n$white: #fff;\n$black: #000;\n$success: #b6fcc9;\n$green: #357a38;\n\n$nitrocamDarkBlue: #151042;\n$nitrocamBlue: #3b00f8;\n$nitrocamRed: #ff161b;\n$nitrocamYellow: #ffe169;\n\n//Heights\n$nav-height: 10vh;\n$main-height: 80vh;\n$footer-height: 6vh;\n\n//Breakpoints\n$mobile: 600px;\n$tablet: 1000px;\n$desktop: 1300px;\n\n//Layout\n@mixin flex($justify: center, $align: center, $direction: row, $gap: 10px) {\n    display: flex;\n    justify-content: $justify;\n    align-items: $align;\n    flex-direction: $direction;\n    gap: $gap;\n}\n\n//MODAL STYLING\n\n@mixin modal($h: auto, $w: auto) {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: $w;\n    height: $h;\n    max-height: 60vh;\n    background-color: #fff;\n    border-radius: 5px;\n    box-shadow: 24;\n    padding: 10px;\n    overflow-y: auto;\n    @media (max-width: 1000px) {\n        width: 92vw;\n    }\n}\n\n//Overflow\n@mixin scrollbars(\n    $size,\n    $foreground-color,\n    $background-color: mix($foreground-color, white, 50%)\n) {\n    // For Google Chrome\n    &::-webkit-scrollbar {\n        width: $size;\n        height: $size;\n    }\n\n    &::-webkit-scrollbar-thumb {\n        background: $foreground-color;\n    }\n\n    &::-webkit-scrollbar-track {\n        background: $background-color;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
